module.exports = __webpack_public_path__ + "media/images/newseye_logo-cce1ec5996435f9342747110ab11b1fb.png";